// src/hooks/order/useOrderHandlers.ts
// Hook para generar handlers simplificados para OrderForm

import { useCallback } from 'react'

interface UseOrderHandlersProps {
  handleInputChange: (section: string, field: string, value: any) => void
  handleEmailValidation: (email: string) => void
}

interface UseOrderHandlersReturn {
  // Handlers para CustomerInfoSection
  handleCustomerFirstNameChange: (value: string) => void
  handleCustomerLastNameChange: (value: string) => void
  handleCustomerEmailChange: (value: string) => void
  handleCustomerPhoneChange: (value: string) => void
  handleCustomerTipoDocumentoChange: (value: string) => void
  handleCustomerDocumentoChange: (value: string) => void
  
  // Handlers para AddressSection
  handleBillingAddressChange: (field: string, value: string) => void
  handleShippingAddressChange: (field: string, value: string) => void
  
  // Handler para notas
  handleNoteChange: (value: string) => void
}

export function useOrderHandlers({
  handleInputChange,
  handleEmailValidation
}: UseOrderHandlersProps): UseOrderHandlersReturn {
  // Handlers para CustomerInfoSection
  const handleCustomerFirstNameChange = useCallback((value: string) => {
    handleInputChange('customer', 'first_name', value)
  }, [handleInputChange])

  const handleCustomerLastNameChange = useCallback((value: string) => {
    handleInputChange('customer', 'last_name', value)
  }, [handleInputChange])

  const handleCustomerEmailChange = useCallback((value: string) => {
    handleEmailValidation(value)
    handleInputChange('customer', 'email', value)
  }, [handleInputChange, handleEmailValidation])

  const handleCustomerPhoneChange = useCallback((value: string) => {
    handleInputChange('shippingAddress', 'phone', value)
  }, [handleInputChange])

  const handleCustomerTipoDocumentoChange = useCallback((value: string) => {
    handleInputChange('customer', 'tipo_documento', value)
  }, [handleInputChange])

  const handleCustomerDocumentoChange = useCallback((value: string) => {
    handleInputChange('customer', 'document', value)
  }, [handleInputChange])

  // Handlers para AddressSection
  const handleBillingAddressChange = useCallback((field: string, value: string) => {
    handleInputChange('billingAddress', field, value)
  }, [handleInputChange])

  const handleShippingAddressChange = useCallback((field: string, value: string) => {
    handleInputChange('shippingAddress', field, value)
  }, [handleInputChange])

  // Handler para notas
  const handleNoteChange = useCallback((value: string) => {
    handleInputChange('extraDetails', 'customer_note', value)
  }, [handleInputChange])

  return {
    handleCustomerFirstNameChange,
    handleCustomerLastNameChange,
    handleCustomerEmailChange,
    handleCustomerPhoneChange,
    handleCustomerTipoDocumentoChange,
    handleCustomerDocumentoChange,
    handleBillingAddressChange,
    handleShippingAddressChange,
    handleNoteChange
  }
}

